import slidesLVLO2 from './slides_LVLO2';
import { featuresLVLO2 } from './features_LVLO2';
import { ProjectType } from '../../Constants';
import { textLVLO2 } from './text_LVLO2';

export const LVLO2data = {
    fr:{
        id: 5,
        name: 'LeVIVO Longueuil 2',
        content: textLVLO2.fr,
        yearBuilt: 2022,
        address: "25 Pl. du Collège, Longueuil, QC J4J 0B1",
        city: "Longueuil",
        brand: "levivo",
        projectPage: "longueuil-2",
        website: "https://levivo.ca/en/rentals-condos/levivo-longueuil-2/",
        category: ProjectType.Residential,
        images: slidesLVLO2,
        features: featuresLVLO2.fr
    },
    en: {
        id: 5,
        name: 'LeVIVO Longueuil 2',
        content: textLVLO2.en,
        yearBuilt: 2022,
        address: "25 Pl. du Collège, Longueuil, QC J4J 0B1",
        city: "Longueuil",
        brand: "levivo",
        projectPage: "longueuil-2",
        website: "https://levivo.ca/en/rentals-condos/levivo-longueuil-2/",
        category: ProjectType.Residential,
        images: slidesLVLO2,
        features: featuresLVLO2.en
    }
    
}